import { DataColumn, DataTable } from './DataTable';
import { ReportFileLink } from './ReportAssets';
import { SheetFigure, SheetTable, useSheet } from './Sheet';

/**
 * Indexes of what the document printed, numbered as it printed. They read
 * the sheet's count, so they must come after everything they list — in the
 * appendix.
 */

const figureColumns: DataColumn<SheetFigure>[] = [
  { key: 'figure', title: 'Figure', render: (r) => <a href={`#${r.anchor}`}>{r.number}</a> },
  { key: 'caption', title: 'Caption', render: (r) => r.caption },
  { key: 'section', title: 'Printed in', render: (r) => r.section ?? '' },
  { key: 'asset', title: 'Source asset', render: (r) => (r.fileId ? <ReportFileLink fileId={r.fileId}>{r.fileName}</ReportFileLink> : r.fileName ?? ''), mono: true },
];

export function FigureIndex({ title = 'Figure index', emptyText = 'The report prints no figures' }: { title?: string; emptyText?: string }) {
  const sheet = useSheet();
  const figures = sheet ? [...sheet.figures] : [];
  return <DataTable title={title} columns={figureColumns} rows={figures} rowKey={(r) => r.key} emptyText={emptyText} wrap />;
}

const tableColumns: DataColumn<SheetTable>[] = [
  { key: 'table', title: 'Table', render: (r) => <a href={`#${r.anchor}`}>{r.number}</a> },
  { key: 'title', title: 'Title', render: (r) => r.title },
  { key: 'section', title: 'Printed in', render: (r) => r.section ?? '' },
];

export function TableIndex({ title = 'Table index', emptyText = 'The report prints no numbered tables' }: { title?: string; emptyText?: string }) {
  const sheet = useSheet();
  const tables = sheet ? [...sheet.tables] : [];
  return <DataTable title={title} columns={tableColumns} rows={tables} rowKey={(r) => r.key} emptyText={emptyText} wrap />;
}
